'use strict';

import './reports.controller';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.pricingReport', {
        url: '/pricingreport',
        templateUrl: 'app/reports/pricingReport.html',
        controller: 'PricingReportCtrl',
        controllerAs: 'prc'
      })
      .state('authenticated.rostersReport', {
        url: '/rostersreport',
        templateUrl: 'app/reports/rostersReport.html',
        controller: 'RosterReportCtrl',
        controllerAs: '$ctrl'
      })
      .state('authenticated.tshirtReport', {
        url: '/tshirtreport',
        templateUrl: 'app/reports/tshirtReport.html',
        controller: 'TshirtReportCtrl',
        controllerAs: '$ctrl'
      })
      .state('authenticated.ticketsReport', {
        url: '/ticketsreport',
        templateUrl: 'app/reports/ticketsReport.html',
        controller: 'TicketsReportCtrl',
        controllerAs: '$ctrl'
      })
  });